import React from 'react';
import { FlagType } from '../../../../../../@types/product.enum';
import { useFlags } from '../../providers/FlagsProvider';
import { Flag } from '../../../../../styled/ProductCard/wrapper';

const pickHighestPrioFlag = (featured?: IFlag, favorite?: IFlag) => {
  if (featured && favorite) {
    return featured.prio < favorite.prio ? featured : favorite;
  }
  return featured || favorite;
};

const AttributeFlag = () => {
  const favoriteFlag = useFlags(FlagType.favorite);
  const featuredFlag = useFlags(FlagType.featured);

  const flag = pickHighestPrioFlag(featuredFlag, favoriteFlag);

  if (!flag) {
    return null;
  }

  return (
    <Flag
      textColor={flag.productBanner?.design.textColor ?? ''}
      bg={flag.productBanner?.design.backgroundColor ?? ''}>
      {flag.productBanner?.text}
    </Flag>
  );
};

export default AttributeFlag;
